const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

const { InspectorControls } = wp.blockEditor;

const {
	PanelBody,
	SelectControl,
	Disabled,
	ToggleControl
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;

import icons from "../../../icons.js";
/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType("wp-apidae/accueil", {
	title: __("Accueil", "wp-apidae"), // Block title.
	description: __("Langues parlées et de documentation", "wp-apidae"),
	icon: {
		foreground: '#EFB114',
		background: '#331F5B',
		src: icons.translation
	},
	supports: {
    align: ['full','wide'],
  },
	example: {
  },
	attributes: {
		languesParlees: {
			type: "boolean",
			default: true,
		},
		languesDocumentation: {
			type: "boolean",
			default: true,
		},
		complementAccueil: {
			type: "boolean",
			default: true,
		},
		show_title: {
			type: "boolean",
			default: true,
		},
		field_tag: {
			type: 'string',
			default: 'h2',
		},
		ss_field_tag: {
			type: 'string',
			default: 'h3',
		},
		align: {
			type: 'string',
			default: '',
		},
	},

	edit: class extends wp.element.Component {
		render() {
			const props = this.props;
			const attributes = props.attributes;

			var template = window.WpApidaeTemplateData.settings;
			const fieldsTags          = window.WpApidaeTemplateData.fieldsTags;

			return [
					<InspectorControls key={"inspector"}>
						<PanelBody title={__("Affichage")}>
						<ToggleControl
								label={ __( 'Langues parlées' ) }
								checked={ attributes.languesParlees }
								onChange={ () => {
									props.setAttributes({ languesParlees: ! attributes.languesParlees });
								} }
							/>
						<ToggleControl
								label={ __( 'Langues documentation' ) }
								checked={ attributes.languesDocumentation }
								onChange={ () => {
									props.setAttributes({ languesDocumentation: ! attributes.languesDocumentation });
								} }
							/>
							<ToggleControl
								label={ __( 'Complément accueil' ) }
								checked={ attributes.complementAccueil }
								onChange={ () => {
									props.setAttributes({ complementAccueil: ! attributes.complementAccueil });
								} }
							/>
						</PanelBody>
						<PanelBody title={__("Options")}>
						<ToggleControl
								label={ __( 'Afficher un titre de section' ) }
								checked={ attributes.show_title }
								onChange={ () => {
									props.setAttributes({ show_title: ! attributes.show_title });
								} }
							/>
							{ true === attributes.show_title &&
							<SelectControl
							label={ __( 'Balise à utiliser' ) }
							value={ attributes.field_tag }
							options={fieldsTags}
							onChange={ newValue => {
								props.setAttributes({
									field_tag: newValue,
								});
							}}
						/>}
						<SelectControl
							label={ __( 'Balise des sous titres' ) }
							value={ attributes.ss_field_tag }
							options={fieldsTags}
							onChange={ newValue => {
								props.setAttributes({
									ss_field_tag: newValue,
								});
							}}
						/>
						</PanelBody>
					</InspectorControls>,
						<Disabled>
						<ServerSideRender
							block="wp-apidae/accueil"
							attributes={attributes}
							urlQueryArgs={{
							settings:template
						}}/>
					</Disabled>
				,
			];
		}
	},

	save: () => {
		return null;
	},
});
